export default "__VITE_ASSET__Br0WNRq___"